import React, { useState } from "react"
import { defPath, fetchPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { Controls } from "../components/layout/menu_help"

import { page } from "../pages/noticias3D"
import Avatar from "./noticias3D"


function App() {
    const anchorNotice = async () => {
        const links = document.querySelectorAll('.anchorNotice') as NodeListOf<HTMLAnchorElement>
        links.forEach(link => {
            link.addEventListener('click', e=>{
                e.preventDefault()
                const target = link.dataset.text,
                    text = link.querySelector('.boxInfo--title') as HTMLElement
                target && localStorage.setItem('camila', target)
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Content',
                    'event_action': 'Button',
                    'event_label':  text?.innerText,
                    'interaction':'true',
                    'component_name': 'Modo_Carrera_Blog',
                    'element_text':  text?.innerText,
                });                  
                window.location.href = "/estadio-aguila/noticia"
            })
        });
    }

    const News = async () => {

        const res = await fetch(`${fetchPath}/aguila/loyalty/news`)
        let dataRes = await res.json()
        if(res.status != 401){
            document.querySelector('.boxNotices__content')?.classList.add('show')
            const boxFirst = document.querySelector('.first') as HTMLElement
            const boxMore = document.querySelector('.customBoxs') as HTMLElement
            if(dataRes){
                const title = dataRes[0].titulo.length > 30 ? dataRes[0].titulo.substr(0, 30) + ' ...' : dataRes[0].titulo
                boxFirst.innerHTML = `
                    <a class="anchorNotice" href="#" data-text="${dataRes[0].id}">
                        <img class="bkArticule" src="${dataRes[0].img_preview.imgurl_raw}" alt="${dataRes[0].img_preview.img_alt}" />
                        <div class="maskImg"></div>
                        <div class="boxInfo">
                            <div class="boxInfo--title">${title}</div>
                            <p class="boxInfo--date">${dataRes[0].fecha}</p>
                            <p class="boxInfo--type type">${dataRes[0].categoria}</p>
                        </div>
                    </a>`
                if(dataRes.length >= 2){
                    dataRes.shift() 
                    for (let index = 0; index < dataRes.length; index++) {
                        const el = dataRes[index];    
                        const titleE = el.titulo.length > 30 ? el.titulo.substr(0, 30) + ' ...' : el.titulo                 
                        boxMore.innerHTML += `                            
                            <div class="boxNotices__content--single ">
                                <a class="anchorNotice" href="#" data-text="${el.id}">
                                    <img class="bkArticule" src="${el.img_preview.imgurl_raw}" alt="${el.img_preview.img_alt}" />
                                    <div class="maskImg"></div>
                                    <div class="boxInfo">
                                        <div class="boxInfo--title">${titleE}</div>
                                        <p class="boxInfo--date">${el.fecha}</p>
                                        <p class="boxInfo--type type">${el.categoria}</p>
                                    </div>
                                </a>
                            </div>                                
                        `                       
                    }                              
                }
            }

            anchorNotice()
        }else{
            document.querySelector('.msnnotFound')?.classList.remove('hidden')
        }
    }
    
    React.useEffect(() => {
        News()
        window.matchMedia("(min-width: 991px)").matches && page()
    }, [])

    return (
        <>
            {/* Page HTML */}

            <section className="notice">
                <NewHeader />
                <Modal />
                <Controls isStadium= {false} />
                {/* <img className="notice--mask" src={`${defPath}/assets/images/notice/maskNotice.png`} alt="" /> */}
                <picture className="notice__bg">
                    <source media="(min-width: 767px)" srcSet={`${defPath}/assets/images/ranking/bg_texture.png`} />
                    <img src={`${defPath}/assets/images/ranking/bg_texture.png`} alt="Background noticias" title="Background noticias" />
                </picture>
                <picture className="">
                    <source media="(max-width: 767px)" srcSet={`${defPath}/assets/images/notice/decorationNM.png`} />
                    <img className="notice--decoration" src={`${defPath}/assets/images/notice/decorationN1.png`} alt="" />
                </picture>
                <div className="notice__content">

                    { window.matchMedia("(min-width: 991px)").matches && <Avatar /> }

                    <div className="notice__content__left">
                        {/* <div className="boxCanvas">
                        </div> */}
                    </div> 
                    <div className="notice__content__right">
                        <div className="boxNotices">
                            <h1 className="boxNotices__title">Lo mejor de la fecha</h1>
                            <div className="boxNotices__subtitle">
                                <p>Entérate de todo lo que pasa en el Estadio Aguila </p>
                            </div>
                            <div className="boxNotices__content">
                                <div className="boxNotices__content--single first">
                                    
                                </div>
                                <div className="customBoxs">

                                </div>
                                
                            </div>
                            <p className="msnnotFound hidden">No hay noticias disponibles</p>
                        </div>
                    </div> 
                </div>
            </section>  
        </>
    )
}
export default App